import { Component, OnInit, OnDestroy, Directive } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { ProjectsService, ProposalsService, ProposalsPeService } from '../services/projects-proposals-service/projects-proposals.service';
import { ManageInnovaService } from './manage-innova.service';

import { RequestChange, ChangeContactRequest } from './interfaces';

@Directive()
class BaseManageComponent implements OnInit, OnDestroy {
  private routeParamsSubs: any;
  public projectInformation: any;
  public projectTasks: any;
  public projectCollaborators: any;
  public projectProposalClients: any;
  public projectProjectClients: any;
  public projectProposalSocis: any;
  public contactList: any;
  public error: any;
  public id: string | number;
  public hourCount: any;
  public hourProj: any;
  public showAsyncProgress: boolean = false;

  public getCollaborators() {
    this.dataService.getCollaborators(<number> this.id)
    .subscribe(
      collaborators => {
        this.projectCollaborators = collaborators;
      },
      error => {
        if (error.status === 404) {
          this.error = {
            status: 404,
            msg: 'No existeix cap treball associat al identificador proporcionat',
            statusText: error.statusText
          };
        }
      }
    );
  }

  public getSocis() {
    this.dataService.getSocis(<string> this.id)
     .subscribe(
       socis => {
         this.projectProposalSocis = socis;
       },
       error => {
         if (error.status === 404) {
           this.error = {
             status: 404,
             msg: 'No existeix cap soci associat al identificador proporcionat',
             statusText: error.statusText
           };
         }
       }
     );
  }

  public getContactesClient() {
    this.dataService.getContactesClient(<string> this.id)
     .subscribe(
       clients => {
         this.projectProjectClients = clients;
       },
       error => {
         if (error.status === 404) {
           this.error = {
             status: 404,
             msg: 'No existeix cap client associat al identificador proporcionat',
             statusText: error.statusText
           };
         }
       }
     );
  }

  public getClients() {
    this.dataService.getClients(<string> this.id)
     .subscribe(
       clients => {
         this.projectProposalClients = clients;
       },
       error => {
         if (error.status === 404) {
           this.error = {
             status: 404,
             msg: 'No existeix cap client associat al identificador proporcionat',
             statusText: error.statusText
           };
         }
       }
     );
  }

  public getcontrolTecnic(): void {
    this.dataService.getHourCount(<string> this.id)
      .subscribe(
        hourCount => {this.hourCount = hourCount;
          this.dataService.getHourProj(<string> this.id)
            .subscribe(
              hourProj => this.hourProj = hourProj,
            error => {
              if (error.status === 404) {
                this.error = {
                  status: 404,
                  msg: 'No existeix cap projecte associat al identificador proporcionat',
                  statusText: error.statusText
                };
              }
            });
        },
        error => {
          if (error.status === 404) {
            this.error = {
              status: 404,
              msg: 'No existeix cap treball associat al identificador proporcionat',
              statusText: error.statusText
            };
          }
        }
      );
  }

  public contactChangeRequested($event: ChangeContactRequest): void {
    let observable;
    let cb: Function;

    this.showAsyncProgress = true;
    switch ($event.action) {
      case 'ADD':
        observable = this.dataService.addContact(<number> this.id, $event.contact);
        cb = (newContact) => {
          this.showAsyncProgress = false;
          this.contactList = [newContact, ...this.contactList];
        };
        break;
      case 'REMOVE':
        const removedId = $event.contact.id;
        observable = this.dataService.deleteContact(<number> this.id, $event.contact);
        cb = () => {
          this.showAsyncProgress = false;
          this.contactList = this.contactList.filter(item => item.id !== removedId);
        };
        break;
      case 'UPDATE':
        observable = this.dataService.updateContact(<number> this.id, $event.contact);
        cb = (updatedRecord) => {
          this.showAsyncProgress = false;
          this.contactList = this.contactList.map(contact => {
            if (contact.id === updatedRecord.id) {
              return updatedRecord;
            }
            return contact;
          });
        };
        break;
      default:
        return;
    }

    observable.subscribe(
      cb,
      (err) => { this.error = err;this.showAsyncProgress = false; }
    );
  }

  public dataChangeRequested($event: RequestChange): void {
    let observable;
    let cb: Function;

    this.showAsyncProgress = true;
    //Innovació amb / sense dades
    if($event.payload.inno){
      if($event.payload.inno.innova_metodologic == '' && 
        $event.payload.inno.innova_dev_informatic == '' && $event.payload.inno.percent_finan_intern == '' &&
        $event.payload.inno.percent_dev_metodologic == '' && $event.payload.inno.percent_dev_informatic == '' &&
        $event.payload.inno.obs_innova_metodologic == '' && $event.payload.inno.obs_innova_dev_informatic == '' &&
        $event.payload.inno.tipus == '')$event.payload.inno = null;
      else $event.payload.inno.codi = $event.payload.data.codi.replace(/\s+/g, "");}

    //Software amb / sense dades
    if($event.payload.soft){
      if($event.payload.soft.back_end == "" && $event.payload.soft.desktop == "" && 
        $event.payload.soft.front_end == "" && $event.payload.soft.observacions == "" && 
        $event.payload.soft.t1_1 == "" && $event.payload.soft.t1_2 == "" && $event.payload.soft.t2_1 == "" && 
        $event.payload.soft.t2_2 == "" && $event.payload.soft.t3_1 == "" && $event.payload.soft.t3_2 == "" && 
        $event.payload.soft.t4_1 == "" && $event.payload.soft.t4_2 == "" && $event.payload.soft.t5_1 == "" && 
        $event.payload.soft.t5_2 == "" && $event.payload.soft.t6_1 == "" && $event.payload.soft.t6_2 == "" && 
        $event.payload.soft.t7_1 == "" && $event.payload.soft.t7_2 == "" && $event.payload.soft.t8_1 == "" && 
        $event.payload.soft.t8_2 == "" && $event.payload.soft.t9_1 == "" && $event.payload.soft.t9_2 == "" && 
        $event.payload.soft.tipus == "")$event.payload.soft = null;
      else $event.payload.soft.codi = $event.payload.data.codi.replace(/\s+/g, "");}

      this.dataService.getClau($event.payload.data.clau).subscribe(clauValida => {
       if(clauValida["clau"] == 'ERR'){
        switch ($event.action) {
         case 'CREATE':
          $event.payload.data.codi=$event.payload.data.codi.replace(/\s+/g, "");
          //Quan es crea des d'una proposta sense projecte es passa com a paràmetre el codi de la proposta
          if(!$event.payload.data.codi)this.route.queryParams.subscribe(params => {$event.payload.data.codi = params['codi']});
          //FI. Quan es crea des d'una proposta sense projecte es passa com a paràmetre el codi de la proposta
          observable = this.dataService.create($event.payload.data);
          cb = (project) => {
            if($event.payload.inno || $event.payload.soft)
              this.updateInnoSoft($event.payload.data.codi, $event.payload.inno, $event.payload.soft);
            this.showAsyncProgress = false;
            this.router.navigate([this.urlParam, project.codi]);
          };
          break;
         case 'UPDATE':
          observable = this.dataService.updateData($event.payload.data.codi, $event.payload.data);
          cb = (project) => {
            if($event.payload.inno || $event.payload.soft)
              this.updateInnoSoft($event.payload.data.codi, $event.payload.inno, $event.payload.soft);
            this.showAsyncProgress = false;
            project.nota = $event.payload.data.nota;//crec que el problema ve per eliminar nota al server - obligatori perquè el camp ve duplicat a proposta i prjecte i només n'hi pot haver 1 -
            this.projectInformation = Object.assign({}, project);
            this.router.navigate([this.urlParam, project.codi]);
          };
          break;
          default:
            this.showAsyncProgress = false;
         }
         observable.subscribe(cb,(err) => { this.error = err;this.showAsyncProgress = false;});
         return true;
      } 
      else {alert("El nom ja existeix.");this.showAsyncProgress = false;return false;}
     });
  }

  public updateInnoSoft(codi, inno, soft){
    this.manageInnovaService.update(<string> codi, {inno: inno, soft: soft})
        .subscribe(updatedInnova => { this.showAsyncProgress = false; });
  }

  public changeCollaborator($event) {
    this.showAsyncProgress = true;

    this.dataService.updateCollaborators(<number> this.id, $event)
      .subscribe(
        () => {
          this.showAsyncProgress = false;
          this.getCollaborators();
        },
        err => { this.getCollaborators();this.error = err;this.showAsyncProgress = false; }
      );
  }

  public changeSociContacteProposal($event) {
    this.showAsyncProgress = true;
    this.dataService.updateSocisContactesProposals(<string> this.id, $event)
      .subscribe(
        () => {
          this.showAsyncProgress = false;
          this.getSocis();
        },
        err => { this.getSocis();this.error = err;this.showAsyncProgress = false; }
      );
  }

  public deleteSociContacteProposal($event) {
    this.showAsyncProgress = true;
    this.dataService.deleteSocisContactesProposals(<string> this.id, $event)
      .subscribe(
        () => {
          this.showAsyncProgress = false;
          this.getSocis();
        },
        err => { this.getSocis();this.error = err;this.showAsyncProgress = false; }
      );
  }

  public changeClientContacteProposal($event) {
    this.showAsyncProgress = true;
    this.dataService.updateClientsContactesProposals(<string> this.id, $event)
      .subscribe(
        () => {
          this.showAsyncProgress = false;
          this.getClients();
        },
        err => { this.getClients();this.error = err;this.showAsyncProgress = false; }
      );
  }

  public deleteClientContacteProposal($event) {
    this.showAsyncProgress = true;
    this.dataService.deleteClientsContactesProposals(<string> this.id, $event)
      .subscribe(
        () => {
          this.showAsyncProgress = false;
          this.getClients();
        },
        err => { this.getClients();this.error = err;this.showAsyncProgress = false; }
      );
  }

  public changeClientContacteProject($event) {
    this.showAsyncProgress = true;
    this.dataService.updateClientsContactesProject(<string> this.id, $event)
      .subscribe(
        () => {
          this.showAsyncProgress = false;
          this.getContactesClient();
        },
        err => { this.getContactesClient();this.error = err;this.showAsyncProgress = false; }
      );
  }

  public deleteClientContacteProject($event) {
    this.showAsyncProgress = true;
    this.dataService.deleteClientsContactesProject(<string> this.id, $event)
      .subscribe(
        () => {
          this.showAsyncProgress = false;
          this.getContactesClient();
        },
        err => { this.getContactesClient();this.error = err;this.showAsyncProgress = false; }
      );
  }

  constructor(
    public translate: TranslateService, 
    public languageService: LanguageService, 
    protected manageInnovaService: ManageInnovaService, 
    protected route: ActivatedRoute,
    protected router: Router,
    protected dataService: ProjectsService | ProposalsService,
    private urlParam: string
  ) {this.ngOnInit();}

  ngOnInit() {
    this.showAsyncProgress = false;
    this.routeParamsSubs = this.route.params.subscribe(params => {
      this.id = params['id'];
      this.showAsyncProgress = false;
      this.dataService.get(this.id)
        .subscribe(
          project => {

            //EStableix canvis i monedes per defecte per evitar peti al fer càlculs al formulari Projectes
            //Pels Projectes
            if(!project['canvi_moneda'])project['canvi_moneda'] = 1;
            if(!project['moneda_pagament'])project['moneda_pagament'] = 'Euro';
            if(!project['moneda_press_proj'])project['moneda_press_proj'] = 'Euro';
            if(!project['canvi_moneda_subcon'])project['canvi_moneda_subcon'] = 1;
            if(!project['moneda_subcon'])project['moneda_subcon'] = 'Euro';
            if(!project['canvi_moneda_subcon2'])project['canvi_moneda_subcon2'] = 1;
            if(!project['moneda_subcon2'])project['moneda_subcon2'] = 'Euro';
            if(!project['canvi_moneda_garantia'])project['canvi_moneda_garantia'] = 1;
            if(!project['moneda_garantia'])project['moneda_garantia'] = 'Euro';

            //Per les Propostes
            if(!project['canvi_moneda_pressupost_licitacio'])project['canvi_moneda_pressupost_licitacio'] = 1;
            if(!project['moneda_pressupost_licitacio'])project['moneda_pressupost_licitacio'] = 'Euro';
            if(!project['canvi_moneda_pressupost_ofertat'])project['canvi_moneda_pressupost_ofertat'] = 1;
            if(!project['moneda_pressupost_ofertat'])project['moneda_pressupost_ofertat'] = 'Euro';
            if(!project['canvi_moneda_import_propi'])project['canvi_moneda_import_propi'] = 1;
            if(!project['moneda_import_propi'])project['moneda_import_propi'] = 'Euro';
            if(!project['canvi_moneda_press_proj'])project['canvi_moneda_press_proj'] = 1;
            if(!project['moneda_press_pro'])project['moneda_press_pro'] = 'Euro';

            this.projectInformation = project;
          },
          error => {
            if (error.status === 404 && this.id !== 'new') {
              this.error = {
                status: 404,
                msg: 'No existeix cap treball associat al identificador proporcionat',
                statusText: error.statusText
              };
              this.router.navigate(['project/new'], { queryParams: {codi: this.id} });
            }
          }
        );
        if (this.id !== 'new') {
          this.dataService.getTask(<number> this.id, {limit : 5})
           .subscribe(
             tasks => {
               this.projectTasks = tasks;
             },
             error => {
               if (error.status === 404) {
                 this.error = {
                   status: 404,
                   msg: 'No existeix cap treball associat al identificador proporcionat',
                   statusText: error.statusText
                 };
               }
             }
           );
           this.getCollaborators();
           this.getcontrolTecnic();
           this.getClients();
           this.getContactesClient(); 
           this.getSocis();
        }
     });
  }

  ngOnDestroy() {
    this.routeParamsSubs.unsubscribe();
  }
}

@Component({
  selector: 'mcrit-gestio-manage-project',
  templateUrl: 'manage-project.component.html',
  styleUrls: ['base-manage.component.css'],
  providers: [ProjectsService, ProposalsService, ProposalsPeService, ManageInnovaService]
})
export class ManageProjectComponent extends BaseManageComponent {
  constructor(public translate: TranslateService, public languageService: LanguageService, 
manageInnovaService: ManageInnovaService, route: ActivatedRoute, router: Router, projectsService: ProjectsService) {
    super(translate, languageService, manageInnovaService, route, router, projectsService, 'project');
  }
}

@Component({
  selector: 'mcrit-gestio-manage-proposal',
  templateUrl: 'manage-proposal.component.html',
  styleUrls: ['base-manage.component.css'],
  providers: [ProjectsService, ProposalsService, ProposalsPeService, ManageInnovaService]
})
export class ManageProposalComponent extends BaseManageComponent {
  constructor(public translate: TranslateService, public languageService: LanguageService, 
manageInnovaService: ManageInnovaService, route: ActivatedRoute, router: Router, proposalsService: ProposalsService) {
    super(translate, languageService, manageInnovaService, route, router, proposalsService, 'proposal');
  }
}

@Component({
  selector: 'mcrit-gestio-manage-proposalpe',
  templateUrl: 'manage-proposal.component.html',
  styleUrls: ['base-manage.component.css'],
  providers: [ProjectsService, ProposalsService, ProposalsPeService, ManageInnovaService]
})
export class ManageProposalPeComponent extends BaseManageComponent {
  constructor(public translate: TranslateService, public languageService: LanguageService, manageInnovaService: ManageInnovaService, route: ActivatedRoute, router: Router, proposalsService: ProposalsPeService) {
    super(translate, languageService, manageInnovaService, route, router, proposalsService, 'proposalpe');
  }
}